/* Polite Society quick add — hover "+" on a product card, pick a size, straight into the bag */
(function () {
  var cache = {};
  var COLOUR = /^(colou?r|shade)$/i, SIZE = /^sizes?$/i;

  function money(cents) {
    try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, window.psMoneyFormat || 'Rs. {{amount_no_decimals}}') : 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN'); } catch (e) { return ''; }
  }
  function load(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return cache[handle];
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function open(card) {
    var handle = card.dataset.handle, panel = card.querySelector('[data-ps-quickpanel]'), btn = card.querySelector('[data-ps-quick]');
    if (!handle || !panel) return;
    closeAll(card);
    card.classList.add('is-quick-loading');
    load(handle).then(function (p) {
      card.classList.remove('is-quick-loading');
      render(card, panel, p);
      panel.hidden = false;
      requestAnimationFrame(function () { card.classList.add('is-quick-open'); btn && btn.setAttribute('aria-expanded', 'true'); });
    }).catch(function () { card.classList.remove('is-quick-loading'); });
  }
  function close(card) {
    var panel = card.querySelector('[data-ps-quickpanel]'), btn = card.querySelector('[data-ps-quick]');
    card.classList.remove('is-quick-open'); btn && btn.setAttribute('aria-expanded', 'false');
    if (panel) setTimeout(function () { if (!card.classList.contains('is-quick-open')) panel.hidden = true; }, 300);
  }
  function closeAll(except) { document.querySelectorAll('.ps-card.is-quick-open').forEach(function (c) { if (c !== except) close(c); }); }

  function render(card, panel, p) {
    var opts = p.options.map(function (o, i) { return { name: o.name || o, position: i + 1, values: o.values || [] }; });
    // single "Title / Default Title" option → add directly
    if (opts.length === 1 && /default title/i.test((opts[0].values[0] || ''))) {
      panel.innerHTML = '<div class="ps-quick__head"><span class="ps-quick__label">Quick add</span><button type="button" class="ps-quick__close" data-ps-quick-close aria-label="Close">' + closeIcon() + '</button></div>' +
        '<button type="button" class="ps-link ps-quick__cta" data-ps-quick-add="' + p.variants[0].id + '">Add to cart — ' + money(p.variants[0].price) + '</button><div class="ps-quick__status"></div>';
      return;
    }
    var sel = {};
    // preselect colour from the card's active swatch
    var active = card.querySelector('[data-ps-swatch].is-active');
    opts.forEach(function (o) {
      if (COLOUR.test(o.name) && active) { var t = (active.getAttribute('title') || '').trim(); if (o.values.indexOf(t) > -1) sel[o.position] = t; }
      if (o.values.length === 1) sel[o.position] = o.values[0];
    });
    var html = '<div class="ps-quick__head"><span class="ps-quick__label" data-ps-quick-title>Select size</span><button type="button" class="ps-quick__close" data-ps-quick-close aria-label="Close">' + closeIcon() + '</button></div>';
    opts.forEach(function (o) {
      if (o.values.length === 1) return;
      html += '<div class="ps-quick__group" data-position="' + o.position + '">' +
        (opts.filter(function (x) { return x.values.length > 1; }).length > 1 ? '<div class="ps-quick__label" style="margin-bottom:.6rem">' + esc(o.name) + '</div>' : '') +
        '<div class="ps-quick__values">' + o.values.map(function (v) {
          return '<button type="button" class="ps-quick__value' + (sel[o.position] === v ? ' is-selected' : '') + '" data-value="' + esc(v) + '">' + esc(v) + '</button>';
        }).join('') + '</div></div>';
    });
    /* Same commit step as the desktop quick view: picking a size only selects,
       the CTA is what adds. (Arnav, 23 Oct) */
    html += '<button type="button" class="ps-link ps-quick__cta" data-ps-quick-cta>Add to cart</button>';
    html += '<div class="ps-quick__status" data-ps-quick-status></div>';
    panel.innerHTML = html;
    panel.__sel = sel; panel.__product = p; panel.__opts = opts;
    markAvailability(panel);
  }
  function closeIcon() { return '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor"/></svg>'; }

  function variantFor(panel, sel) {
    var p = panel.__product;
    return p.variants.find(function (v) {
      return panel.__opts.every(function (o) { return sel[o.position] === undefined || v['option' + o.position] === sel[o.position]; });
    });
  }
  function markAvailability(panel) {
    var p = panel.__product, sel = panel.__sel;
    panel.querySelectorAll('.ps-quick__group').forEach(function (g) {
      var pos = +g.dataset.position;
      g.querySelectorAll('.ps-quick__value').forEach(function (b) {
        var test = Object.assign({}, sel); test[pos] = b.dataset.value;
        var ok = p.variants.some(function (v) {
          return v.available && panel.__opts.every(function (o) { return test[o.position] === undefined || v['option' + o.position] === test[o.position]; });
        });
        b.classList.toggle('is-unavailable', !ok);
      });
    });
  }

  function add(card, panel, variantId) {
    var status = panel.querySelector('[data-ps-quick-status]');
    if (status) { status.textContent = 'Adding…'; status.classList.remove('is-ok'); }
    var fd = new FormData();
    fd.append('id', variantId); fd.append('quantity', 1);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) { if (status) status.textContent = res.description || res.message || 'Could not add'; return; }
        if (status) { status.textContent = 'Added to bag'; status.classList.add('is-ok'); }
        if (drawer && drawer.renderContents && res.sections) { drawer.renderContents(res); }
        else { document.dispatchEvent(new CustomEvent('ps:cart:added', { detail: res })); window.location.href = '/cart'; }
        setTimeout(function () { close(card); }, 900);
      })
      .catch(function () { if (status) status.textContent = 'Could not add — try again'; });
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-ps-quick]');
    if (quick) { e.preventDefault(); e.stopPropagation(); var card = quick.closest('.ps-card'); card.classList.contains('is-quick-open') ? close(card) : open(card); return; }
    var closeBtn = e.target.closest('[data-ps-quick-close]');
    if (closeBtn) { e.preventDefault(); close(closeBtn.closest('.ps-card')); return; }
    var addBtn = e.target.closest('[data-ps-quick-add]');
    if (addBtn) { e.preventDefault(); var c = addBtn.closest('.ps-card'); add(c, c.querySelector('[data-ps-quickpanel]'), addBtn.dataset.psQuickAdd); return; }
    var cta = e.target.closest('[data-ps-quick-cta]');
    if (cta) {
      e.preventDefault();
      var ctaCard = cta.closest('.ps-card'), ctaPanel = ctaCard.querySelector('[data-ps-quickpanel]');
      var ctaStatus = ctaPanel.querySelector('[data-ps-quick-status]');
      var ctaDone = ctaPanel.__opts.every(function (o) { return ctaPanel.__sel[o.position] !== undefined; });
      if (!ctaDone) { if (ctaStatus) { ctaStatus.textContent = 'Please select a size'; ctaStatus.classList.remove('is-ok'); } return; }
      var ctaV = variantFor(ctaPanel, ctaPanel.__sel);
      if (!ctaV || !ctaV.available) { if (ctaStatus) { ctaStatus.textContent = 'Sold out in this size'; ctaStatus.classList.remove('is-ok'); } return; }
      add(ctaCard, ctaPanel, ctaV.id);
      return;
    }
    var val = e.target.closest('.ps-quick__value');
    if (val) {
      e.preventDefault();
      var card2 = val.closest('.ps-card'), panel = card2.querySelector('[data-ps-quickpanel]'), group = val.closest('.ps-quick__group'), pos = +group.dataset.position;
      group.querySelectorAll('.ps-quick__value').forEach(function (b) { b.classList.remove('is-selected'); });
      val.classList.add('is-selected');
      panel.__sel[pos] = val.dataset.value;
      markAvailability(panel);
      var status = panel.querySelector('[data-ps-quick-status]');
      if (status) { status.textContent = ''; status.classList.remove('is-ok'); }
      return;
    }
    if (!e.target.closest('.ps-card')) closeAll();
  });
  // desktop: hovering the "+" opens the panel; leaving the card closes it
  document.addEventListener('mouseover', function (e) {
    var quick = e.target.closest('[data-ps-quick]');
    if (quick && window.matchMedia('(hover: hover)').matches) { var card = quick.closest('.ps-card'); if (!card.classList.contains('is-quick-open')) open(card); }
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('.ps-card');
    if (card && card.classList.contains('is-quick-open') && (!e.relatedTarget || !card.contains(e.relatedTarget))) close(card);
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeAll(); });
})();
